const TrialResultContent = () => {
    return (
        <>
            <h4>
                IBIS-I Clinical Trial Results 
            </h4>
            <p>
                Long-term results of the IBIS-I clinical trial confirms that tamoxifen, a well-established treatment for breast cancer, also reduces the risk of hormone receptor positive breast cancer by 34% in women at increased risk of the disease, and that the benefit continued for at least several years even after treatment when the drug had stopped. 
            </p>
        </>
    );
}

export default TrialResultContent;